var path = 'widget/lib/display-columns-panel.tpl.html';
var html = " <md-content style=height:100% flex layout=column class=md-padding> <label class=tb-title translate>entity.columns-to-display</label> <md-checkbox aria-label=\"{{ 'entity.columns-to-display' | translate }}\" ng-repeat=\"column in vm.columns\" ng-model=column.display>{{ column.title }} </md-checkbox> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/lib/display-columns-panel.tpl.html
// module id = 524
// module chunks = 1